import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const mediaSrc = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

// Drag-to-compare before/after photo slider
export const BeforeAfter = ({ before, after, caption, testid }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const set = (e) => { const r = ref.current.getBoundingClientRect(); setPos(Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100))); };
  return (
    <figure className="space-y-2" data-testid={testid}>
      <div ref={ref} onPointerDown={(e) => { e.currentTarget.setPointerCapture(e.pointerId); set(e); }} onPointerMove={(e) => e.buttons && set(e)}
        className="relative aspect-[4/3] rounded-2xl overflow-hidden select-none touch-none cursor-ew-resize border border-white/10">
        <img src={mediaSrc(after)} alt="After" draggable={false} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={mediaSrc(before)} alt="Before" draggable={false} className="absolute inset-0 w-full h-full object-cover" />
        </div>
        <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_12px_rgba(56,189,248,0.9)]" style={{ left: `${pos}%` }}>
          <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-sky-500 text-white flex items-center justify-center shadow-lg"><ChevronsLeftRight className="w-4 h-4" /></span>
        </div>
        <span className="absolute top-3 left-3 text-[11px] uppercase tracking-widest bg-black/60 text-white px-2 py-0.5 rounded">Before</span>
        <span className="absolute top-3 right-3 text-[11px] uppercase tracking-widest bg-sky-500/80 text-white px-2 py-0.5 rounded">After</span>
      </div>
      {caption && <figcaption className="text-sm text-gray-400">{caption}</figcaption>}
    </figure>
  );
};

export const BeforeAfterGallery = ({ items }) => (items?.length ? (
  <section className="mb-10 space-y-4" data-testid="before-after-gallery">
    <p className="text-sky-500 text-xs tracking-[0.3em] uppercase">Real results</p>
    <div className="grid sm:grid-cols-2 gap-5">{items.map((g, i) => <BeforeAfter key={i} {...g} testid={`before-after-${i}`} />)}</div>
  </section>
) : null);
